import React, { useState, useEffect } from 'react';
import { BaseTextFieldProps } from '@material-ui/core/TextField';
import TextField from '@material-ui/core/TextField';

export interface PriceCommaTextField extends BaseTextFieldProps {
  onChange: (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
    value: number | null
  ) => void;
  onBlur?: () => void;
  value: number | null;
  type?: 'text';
  maxDigit: number; // 最大で16桁まで
}

const formatter = new Intl.NumberFormat('ja-JP'); // 16桁までしか対応していない

const PriceCommaTextField = (props: PriceCommaTextField) => {
  const { value, onChange, type, maxDigit, onBlur, ...rest } = props;

  const [values, setValues] = useState({
    displayValue: addComma(value),
    value: value,
  });

  useEffect(() => {
    if (value !== values.value) {
      setValues({ displayValue: addComma(value), value: value });
    }
    // values.value は毎描画ごとに変更されてしまうため第二引数から除外する
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const onChangeValue = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    const inputValue = e.target.value.replaceAll(',', '');
    if (!/^[0-9]*$/.test(inputValue) || maxDigit < inputValue.length) {
      return;
    }
    setValues({
      displayValue: inputValue,
      value: inputValue === '' ? null : Number(inputValue),
    });
    onChange(e, inputValue === '' ? null : Number(inputValue));
  };

  return (
    <TextField
      onChange={(e) => onChangeValue(e)}
      onBlur={() => {
        setValues({
          displayValue: addComma(values.value),
          value: values.value,
        });
        onBlur && onBlur();
      }}
      onFocus={() =>
        setValues({ displayValue: String(values.value), value: values.value })
      }
      value={values.displayValue === 'null' ? '' : values.displayValue}
      type='text'
      {...rest}
    />
  );
};

function addComma(price: number | null): string {
  if (price !== 0 && !price) {
    return '';
  }
  return formatter.format(price);
}

export default PriceCommaTextField;
